import { Link, useNavigate } from "react-router-dom";

import { handleToken } from "@helpers/utils";
import themeConfig from "@configs/theme-config";
import { useEffect } from "react";

const NotAuthorized = (props) => {
  const { showBtn = true, internal = false } = props;
  const navigate = useNavigate();
  // ** Hooks
  useEffect(() => {
    if (!handleToken()) {
      navigate("/");
    }
  }, []);

  const {
    app: { logo }
  } = themeConfig;

  // ** Vars
  return (
    <>
      <div className="flex min-h-screen flex-col items-center justify-center text-center p-4">
        {!internal && (
          <Link
            to="/"
            className="mb-6 flex items-center justify-center gap-2.5"
          >
            <img
              src={logo}
              alt="NookPay"
              className="h-10 w-10 rounded-xl object-cover"
            />
            <span className="text-lg font-semibold tracking-tight text-gray-900">
              NookPay
            </span>
          </Link>
        )}
        <div className="relative max-w-[750px] p-6 sm:p-12">
          <div className="w-full text-center">
            <h2 className="mb-3">You are not authorized! 🔐</h2>
            <br />
            {showBtn ? (
              <Link to="/">
                <span className="inline-flex w-full items-center justify-center gap-2 rounded bg-primary px-4 py-2 text-sm font-medium text-white transition hover:opacity-90 sm:w-auto mb-4">
                  Back to home
                </span>
              </Link>
            ) : (
              <h5>
                You will need to contact your account manager for permissions
              </h5>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default NotAuthorized;
